import { type FormErrors } from '@mantine/form'
import { zodResolver } from '@front/model'
import { getReviewRoutingErrors, getReviewRoutingState } from './reviewRouting'
import { CompanyCardFormValuesSchema, type CompanyCardFormValues } from './components/CompanyCardFields'

export function getMyCardValidationErrors(
  values: CompanyCardFormValues,
  translate: (message: string) => string
): FormErrors {
  const errors = zodResolver(CompanyCardFormValuesSchema)(values)
  if (!getReviewRoutingState(values).showFeedbackFields) delete errors.teamInboxEmail
  return { ...errors, ...getReviewRoutingErrors(values, translate) }
}
